/**
 * Native frontend plugin registration for @backstage-community/plugin-bazaar.
 *
 * `convertLegacyPlugin` has been removed. The plugin is now registered as a native
 * `FrontendPlugin` via `createFrontendPlugin`. `bazaarApiRef` and `BazaarClient`
 * are not in the package's public type surface, so they are imported from the
 * internal dist path (fragile — will break on upstream restructure).
 *
 * PARTIAL DEFERRED — `convertLegacyRouteRef` call remains.
 * Status: BLOCKED (upstream) — route ref is not exported from the public API,
 * so `convertLegacyRouteRef` bridge is still required.
 * Also: bazaarApiRef/BazaarClient internal dist import is fragile.
 *
 * Migration path: Wait for upstream to export route refs and API symbols publicly
 * (or publish a `/alpha` export).
 * Upstream: https://github.com/backstage/community-plugins/tree/main/workspaces/bazaar/plugins/bazaar
 */
import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { bazaarPlugin } from '@backstage-community/plugin-bazaar';
// @ts-ignore - bazaarApiRef/BazaarClient not in public type surface
import { bazaarApiRef, BazaarClient } from '@backstage-community/plugin-bazaar/dist/api.esm.js';

const nativeBazaarRouteRef = convertLegacyRouteRef(bazaarPlugin.routes.root);

const bazaarApi = ApiBlueprint.make({
  name: 'bazaar',
  params: define =>
    define(
      createApiFactory({
        api: bazaarApiRef,
        deps: {
          identityApi: identityApiRef,
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ identityApi, discoveryApi, fetchApi }) =>
          new BazaarClient({ identityApi, discoveryApi, fetchApi }),
      }),
    ),
});

const bazaarPage = PageBlueprint.make({
  params: {
    path: '/bazaar',
    routeRef: nativeBazaarRouteRef,
    loader: async () => {
      const { BazaarPage } = await import('@backstage-community/plugin-bazaar');
      return <BazaarPage />;
    },
    noHeader: true,
  },
});

export default createFrontendPlugin({
  pluginId: 'bazaar',
  routes: {
    root: nativeBazaarRouteRef,
  },
  extensions: [bazaarApi, bazaarPage],
});
